export const OWNABLE = 50;
